// The sellable plans, in order. Mirrors backend/models/user.py TIERS (names,
// prices) for the places that NAME a plan outside the pricing page: the
// limit-reached modal and the feature-lock prompts still said "Starter $15" /
// "Pro $35" two months after the 2026-09-08 rename (found 2026-11-02), and
// "Score History" claimed to need Premium when Analyst has it.
export const PLANS = {
  free: { name: 'Free', price: 0 },
  core: { name: 'Core', price: 10.99 },
  analyst: { name: 'Analyst', price: 24 },
  premium: { name: 'Premium', price: 65 },
  power: { name: 'Power', price: 149 }, // owner/internal only, never offered
};

export const PLAN_ORDER = ['free', 'core', 'analyst', 'premium'];

// Retired names still on old accounts resolve like the backend's resolve_tier().
const ALIASES = { starter: 'core', pro: 'analyst' };
export const resolvePlan = (tier) => ALIASES[(tier || 'free').toLowerCase()] || (tier || 'free').toLowerCase();

export const planName = (tier) => (PLANS[resolvePlan(tier)] || PLANS.free).name;

export const planPrice = (tier) => {
  const p = (PLANS[resolvePlan(tier)] || PLANS.free).price;
  return Number.isInteger(p) ? `$${p}` : `$${p.toFixed(2)}`;
};

// The next plan up from `tier`, or null at the top.
export function nextPlan(tier) {
  const i = PLAN_ORDER.indexOf(resolvePlan(tier));
  const key = i >= 0 && i < PLAN_ORDER.length - 1 ? PLAN_ORDER[i + 1] : null;
  return key ? { key, name: PLANS[key].name, price: `${planPrice(key)}/mo` } : null;
}

// Lowest plan with each gated feature (backend TIERS[...].features).
export const FEATURE_MIN_PLAN = {
  holdings_full: 'analyst',
  dividend_tracker: 'analyst',
  etf_overlap: 'analyst',
  trade_simulator: 'analyst',
  benchmark: 'analyst',
  score_history: 'analyst',
  ai_chat: 'free',
  portfolio_builder: 'free',
  ai_thesis: 'premium',
  earnings_summary: 'premium',
  alpha_memory: 'premium',
  portfolio_alerts: 'premium',
};
